export interface SubscriptionPlan {
    primary?: boolean;
    secondary?: boolean;
    warning?: boolean;
    info?: boolean;
    outline?: boolean;
    textColor: string;
    name: string;
}

export const SubscriptionPlanMetadata: { [key: string]: SubscriptionPlan }  = {
    "personalized-subscription": {
        outline: true,
        primary: true,
        textColor: "white",
        name: "Abonnement Particulier",
    },
    "wetalk": {
        outline: true,
        textColor: "white",
        name: "We talk Basic"
    },
    "wetalk-plus": {
        info: true,
        textColor: "white",
        name: "We talk Plus"
    },
    "wetalk-coach": {
        secondary: true,
        textColor: "white",
        name: "We talk Coach"
    }
};
